import * as types from '../../actionTypes'

const initialState = {
  file: null,
  fileName: '',
  uploadResults: null,
  isLoading: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ROSTER_FILE_SELECTED:
    case types.ROSTER_FILE_SUBMITTING:
    case types.ROSTER_FILE_SUCCEEDED:
    case types.ROSTER_FILE_ERROR:
      const { error, data, type } = action
      let file
      let fileName = ''
      if (data) {
        file = data.file
      } else {
        file = action.file
      }
      if (file) {
        fileName = file.name
      }
      return {
        ...state,
        file: file,
        fileName: fileName,
        uploadResults: type === types.ROSTER_FILE_SUCCEEDED ? data : null,
        isLoading: type === types.ROSTER_FILE_SUBMITTING,
        error: type === types.ROSTER_FILE_ERROR ? error : null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/roster/rosterManager.js